import { render, staticRenderFns } from "./FoodRegistrationForm.vue?vue&type=template&id=bfa8c688&scoped=true&lang=html"
import script from "./FoodRegistrationForm.vue?vue&type=script&lang=js"
export * from "./FoodRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./FoodRegistrationForm.vue?vue&type=style&index=0&id=bfa8c688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa8c688",
  null
  
)

export default component.exports